import React, { useCallback } from 'react'
import { VirtualizedList } from './VirtualizedList'

export const ShimmerVirtualizedList = ({ rows, rowRenderer, shimmerComponent: Shimmer, ...rest }) => {
  const customRowRenderer = useCallback(
    props => {
      const { index } = props
      const found = !!rows[index]
      if (!found) {
        const { key, style } = props
        return <Shimmer key={key} style={style} />
      }
      return rowRenderer(props)
    },
    // https://github.com/facebook/react/issues/18051
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rows, rowRenderer, Shimmer]
  )

  return <VirtualizedList rows={rows} rowRenderer={customRowRenderer} {...rest} />
}
